export default function PHP_XMLDOM() {
  return (
    <div>
      <h1>PHP_XMLDOM</h1>
    </div>
  );
}
